document.addEventListener('DOMContentLoaded', () => {
  const regex = /\$\d+(?:\.\d+)?/;
  const selectors = ['.media-hero__price', '.comparison-option__price', '.comparison-option__disclaimer'];
  const currencyRate = Number(window.Shopify.currency.rate);

  const convertLocalCurrency = (amount) => {
    return (amount * currencyRate).toFixed(2);
  };

  selectors.forEach((selector) => {
    const elements = document.querySelectorAll(selector);
    elements.forEach((el) => {
      const text = el.textContent.trim();
      const prices = text.match(regex);

      if (prices) {
        prices.forEach((priceString) => {
          const priceNumber = Number(priceString.replace('$', ''));
          const convertedPrice = convertLocalCurrency(priceNumber);
          const newPrice = window.AllstoraCurrency.symbol + convertedPrice;
          el.textContent = el.textContent.replace(priceString, newPrice);
        });
      }
    });
  });
});
